<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <div>
          <div>
            <h6 class="heading-small text-muted mb-4">Template</h6>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="selectedAccountReportTemplateId"
                  style="width: 100%"
                  placeholder="Select Template"
                  :filter-option="filterOption"
                  @change="
                    (event) => {
                      setAccountReportTemplate(event);
                      setOrigConfig(event);
                    }
                  "
                >
                  <a-select-option
                    v-for="template in options.accountReportTemplates"
                    :value="template.id"
                    :key="template.id"
                    :label="template.name"
                  >
                    {{ template.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
        </div>
        <br />
        <form role="form" @submit.prevent>
          <h6 class="heading-small text-muted mb-4">Filters</h6>
          <div>
            <div>
              <label>Date (From - To)</label>
            </div>
            <div class="row">
              <div class="col">
                <base-input>
                  <a-range-picker
                    v-model="table.appendedParams.transaction_date_range"
                    :default-value="[
                      table.appendedParams.transaction_date_from,
                      table.appendedParams.transaction_date_to
                    ]"
                    :format="dateFormat"
                    @change="dateRangeOnChange"
                  />
                </base-input>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Company</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.companies"
                  style="width: 100%"
                  mode="multiple"
                  :filter-option="filterOption"
                  placeholder="Select Companies"
                >
                  <a-select-option
                    v-for="company in options.companies"
                    :value="company.id"
                    :key="company.id"
                    :label="company.name"
                  >
                    {{ company.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Site Concept</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.site_concepts"
                  style="width: 100%"
                  mode="multiple"
                  :filter-option="filterOption"
                  placeholder="Select Site Concept"
                >
                  <a-select-option
                    v-for="siteConcept in options.siteConcepts"
                    :value="siteConcept.id"
                    :key="siteConcept.id"
                    :label="siteConcept.name"
                  >
                    {{ siteConcept.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Site</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.site_ids"
                  mode="multiple"
                  style="width: 100%"
                  :filter-option="filterOption"
                  placeholder="Select Sites"
                >
                  <a-select-option
                    v-for="site in options.sites"
                    :value="site.id"
                    :key="site.id"
                    :label="site.name"
                  >
                    {{ site.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Transaction Type</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.transaction_types"
                  style="width: 100%"
                  mode="multiple"
                  :filter-option="filterOption"
                  placeholder="Select Transaction Type"
                >
                  <a-select-option
                    v-for="transactionType in options.transactionTypes"
                    :value="transactionType.id"
                    :key="transactionType.id"
                    :label="transactionType.name"
                  >
                    {{ transactionType.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Customer Type</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.customer_types"
                  style="width: 100%"
                  mode="multiple"
                  :filter-option="filterOption"
                  placeholder="Select Transaction Type"
                >
                  <a-select-option
                    v-for="customerType in options.customerTypes"
                    :value="customerType.id"
                    :key="customerType.id"
                    :label="customerType.name"
                  >
                    {{ customerType.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Member ID</label>
            </div>
            <div class="row">
              <div class="col">
                <base-input>
                  <a-input
                    placeholder="Member ID"
                    v-model="table.appendedParams.membership_number"
                  />
                </base-input>
              </div>
            </div>
          </div>
          <!-- <div>
            <div>
              <label>Card Number</label>
            </div>
            <div class="row">
              <div class="col">
                <base-input>
                  <a-input
                    placeholder="Card Number"
                    v-model="table.appendedParams.card_numbers"
                  />
                </base-input>
              </div>
            </div>
          </div> -->
          <div>
            <div>
              <label>Name</label>
            </div>
            <div class="row">
              <div class="col">
                <base-input>
                  <a-input
                    placeholder="First Name/ Last Name"
                    v-model="table.appendedParams.name"
                  />
                </base-input>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Status</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.status"
                  mode="multiple"
                  style="width: 100%"
                  :filter-option="filterOption"
                  placeholder="Select Status"
                >
                  <a-select-option value="P"> Posted </a-select-option>
                  <a-select-option value="V"> Voided </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <!-- <div>
            <div>
              <label>Terminal Code</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.terminal_codes"
                  mode="multiple"
                  style="width: 100%"
                  :filter-option="filterOption"
                  placeholder="Select Terminal Code"
                >
                  <a-select-option
                    v-for="terminalCode in options.terminalCodes"
                    :value="terminalCode.terminal_code"
                    :key="terminalCode.terminal_code"
                    :label="terminalCode.terminal_code"
                  >
                    {{ terminalCode.terminal_code }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div> -->
          <div>
            <div>
              <label>Transaction ID</label>
            </div>
            <div class="row">
              <div class="col">
                <base-input>
                  <a-input
                    placeholder="Transaction ID"
                    v-model="table.appendedParams.transaction_ids"
                  />
                </base-input>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col">
              <base-button
                type="primary btn-block"
                class="my-4"
                @click.prevent="setFilter"
              >
                <div>Apply Filter</div>
              </base-button>
            </div>
          </div>
        </form>
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.appendedParams"
          :sortOrder="table.sortOrder"
          :sortParams="getSortParam"
          :multiSort="table.multiSort"
          :multiSortKey="table.multiSortKey"
        >
          <template #headerButtons>
            <div>
              <b-button
                v-if="selectedActions.includes('Customize')"
                variant="primary"
                @click.prevent="openDrawer('report_template')"
                >Customize</b-button
              >
              <b-button
                v-if="
                  selectedActions.includes('Download') ||
                  selectedActions.includes('Send')
                "
                variant="danger"
                @click.prevent="openDrawer('export_data')"
                >Export</b-button
              >
            </div>
          </template>

          <template #formDrawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <AccountReportTemplate
                v-if="drawer.action == 'report_template'"
                :accountReport="accountReport"
                :accountReportTemplate="accountReportTemplate"
                :selectedAccountReportTemplateColumns="tableFields"
                :selectedAccountReportTemplateFilters="table.appendedParams"
                :selectedAccountReportTemplateSorts="table.sortOrder"
                :updatedFilter="updatedFilters"
                @setTableColumns="setTableColumns"
                @setAccountReportTemplate="getAccountReportData"
                @deleteAccountReportTemplate="getAccountReportData"
                @closeDrawer="closeDrawer"
                @setUpdatedFilter="updatedFilters = false"
              />

              <ExportDataForm
                v-if="drawer.action == 'export_data'"
                :jsonFields="toJsonFields"
                :apiUrl="tableApiUrl"
                :filename="filename"
                :template="selectedAccountReportTemplateId"
                :from="exportSource"
                :type="fileType"
                @closeDrawer="closeDrawer"
              />
            </a-drawer>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import HTTPRequest from '../../../controllers/httpRequest';
import PageHeader from '../../../components/Page/Header.vue';
import PageContent from '../../../components/Page/Content.vue';
import PageTable from '../../../components/Page/Table.vue';
import AccountReportTemplate from '../Drawers/AccountReportTemplateForm.vue';
import ExportDataForm from '../Drawers/ExportDataForm.vue';
import secureStorage from '../../../controllers/secureStorage';
import { mapGetters } from 'vuex';
import moment from 'moment-timezone';

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    AccountReportTemplate,
    ExportDataForm
  },
  data() {
    return {
      exportSource: 'transactionReport',
      fileType: 'xls',
      filename: `Report - ${moment().format('YYYY-MM-DDTHHmmss.SSS')}.xls`,
      updatedFilters: false,
      originalFilter: null,
      gradientType: 'gradient-yellow',
      accountReport: null,
      dateFormat: 'YYYY-MM-DD',
      accountReportTemplate: null,
      selectedAccountReportTemplateId: null,
      saveFilters: false,
      saveSorts: false,
      drawer: {
        visible: false,
        width: 600,
        placement: 'right',
        action: null
      },
      table: {
        title: 'Transaction Reports',
        apiUrl:
          '/api/v1/reports/transactions?origin_site_id=' +
          secureStorage.getItem('currentSiteId'),
        fields: [],
        appendedParams: {
          name: '',
          status: [],
          membership_number: '',
          first_name: null,
          last_name: null,
          card_numbers: '',
          site_ids: [],
          transaction_types: [],
          terminal_codes: [],
          customer_types: [],
          site_concepts: [],
          companies: [],
          transaction_ids: '',
          transaction_date_range: [
            moment(new Date()).format('YYYY-MM-DD'),
            moment(new Date()).format('YYYY-MM-DD')
          ],
          transaction_date_from: moment(new Date()).format('YYYY-MM-DD'),
          transaction_date_to: moment(new Date()).format('YYYY-MM-DD'),
          report_type: 'list',
          export_data: false,
          filter: false
        },
        multiSort: true,
        multiSortKey: 'alt',
        sortOrder: null
      },
      options: {
        terminalCodes: [],
        customerTypes: [],
        transactionTypes: [],
        sites: [],
        reportTypes: [{ id: 'list', name: 'Listing' }],
        reportTemplates: [],
        accountReportTemplates: null,
        siteConcepts: [],
        companies: []
      }
    };
  },
  methods: {
    filterOption(inputValue, option) {
      return (
        option?.componentOptions?.propsData?.label
          .toLowerCase()
          .indexOf(inputValue.toLowerCase()) !== -1
      );
    },
    async getTransactionTypes() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_transaction_types',
        {
          per_page: 1000
        }
      );
      this.options.transactionTypes = response.data;
    },
    async getCustomerTypes() {
      const response = await HTTPRequest.getRequest('/api/v1/customer_types', {
        per_page: 1000
      });
      this.options.customerTypes = response.data;
    },

    async getSiteConcepts() {
      const response = await HTTPRequest.getRequest('/api/v1/site_concepts', {
        per_page: 1000
      });
      this.options.siteConcepts = response.data;
    },

    async getCompanies() {
      const response = await HTTPRequest.getRequest('/api/v1/companies', {
        per_page: 1000
      });
      this.options.companies = response.data;
    },
    async getFilters() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/reports/transactions/terminal-codes'
      );
      this.options.terminalCodes = response;
    },

    async getSites() {
      // Refactoring code for getting sites
      // const defaultSite = secureStorage.getItem('defaultSite');
      // if (this.inHeadOffice) {
      //   this.options.sites = secureStorage.getItem('visitingSites');
      // } else {
      //   this.options.sites = [secureStorage.getItem('currentSite')];
      // }
      // this.table.appendedParams.site_ids.push(defaultSite.id);

      const response = await HTTPRequest.getRequest('/api/v1/sites', {
        per_page: 1000
      });
      this.options.sites = response.data;
    },

    async getAccountReportData() {
      let accountReport = [];

      accountReport = await HTTPRequest.getRequest(
        '/api/v1/account_reports/TRANSACTION_REPORTS_LIST/default'
      );
      this.accountReport = accountReport;
      await this.setAccountReportTemplate(
        accountReport.accountReportTemplates[0]
      );
      this.setOrigConfig(accountReport.accountReportTemplates[0]);
      await this.getAccountReportTemplates();
    },
    async getAccountReportTemplates() {
      const data = await HTTPRequest.getRequest(
        '/api/v1/account_report_templates/' +
          this.accountReport.code +
          '/templates'
      );
      this.options.accountReportTemplates = data;
    },

    setAccountReportTemplate(accountReportTemplate) {
      let accountReportTemplateData;
      if (typeof accountReportTemplate == 'number') {
        this.selectedAccountReportTemplateId = accountReportTemplate;
        for (const template of this.options.accountReportTemplates) {
          if (accountReportTemplate == template.id) {
            this.accountReportTemplate = template;
            accountReportTemplateData = JSON.parse(template.config);
          }
        }
      } else {
        this.accountReportTemplate = accountReportTemplate;
        accountReportTemplateData = JSON.parse(accountReportTemplate.config);
        this.selectedAccountReportTemplateId = accountReportTemplate.id;
      }

      /** Clear the previous' template's filter/s */
      this.clearTableFilters();

      /** Clear the previous' template's sort/s */
      this.clearTableSorts();

      /** Load template's default columns */
      this.setTableColumns(accountReportTemplateData.columns);

      if (
        accountReportTemplateData.filters &&
        Object.keys(accountReportTemplateData.filters).includes('source')
      ) {
        const spreadFilter = { ...accountReportTemplateData.filters };
        delete spreadFilter['source'];
        accountReportTemplateData.filters = spreadFilter;
      }
      /** Load template's default filters */
      this.setTableFilters(accountReportTemplateData.filters);

      /** Load template's default sort */
      this.setTableSorts(accountReportTemplateData.sorts);
    },

    setTableColumns(columns = []) {
      /**
       * Note: Amongst the other 2 methods on clearing the table fields,
       * this one worked as this doesn't alter the original array instance
       *
       * this.table.fields = this.table.fields.splice(0, this.table.fields.length);
       * this.table.fields = [];
       * */
      /** Clear table fields */
      this.table.fields.length = 0;

      const tableFields = this.table.fields;

      columns.forEach((column) => {
        /** Check if current "column" is already in the table */ ``;
        let hasField = tableFields.find((field) => field.name === column.name);

        if (typeof hasField === 'undefined') {
          if (Object.keys(column).includes('value')) {
            if (column.value) {
              /** Push to table */
              // console.log('Pushing column: ', column.name);
              if (column.name == 'date') {
                column.formatter = function (date) {
                  if (moment(date).isValid()) {
                    return moment(date).format('YYYY-MM-DD h:mm A');
                  }
                  return null;
                };
              }
              if (column.name == 'status') {
                column.formatter = function (value) {
                  if (value === 'P') {
                    return 'Posted';
                  }
                  if (value === 'V') {
                    return 'Voided';
                  }
                  return null;
                };
              }
              if (column.name == 'amount_gross') {
                column.formatter = function (value) {
                  if (value) {
                    return Number(value).toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    });
                  }
                  return null;
                };
              }
              if (column.name == 'points_earned') {
                column.formatter = function (value) {
                  if (value || value === 0) {
                    return Number(value).toLocaleString('en-US', {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0
                    });
                  }
                  return null;
                };
              }
              if (column.name == 'pos_transaction_type') {
                column.formatter = function (value) {
                  return value;
                };
              }
              this.table.fields.push(column);
            }
          } else {
            /** Push to table */
            // console.log('Pushing column: ', column.name);
            if (column.name == 'date') {
              column.formatter = function (date) {
                if (moment(date).isValid()) {
                  return moment(date).format('YYYY-MM-DD h:mm A');
                }
                return null;
              };
            }
            if (column.name == 'status') {
              column.formatter = function (value) {
                if (value === 'P') {
                  return 'Posted';
                }
                if (value === 'V') {
                  return 'Voided';
                }
                return null;
              };
            }
            if (column.name == 'amount_gross') {
              column.formatter = function (value) {
                if (value) {
                  return Number(value).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  });
                }
                return null;
              };
            }
            if (column.name == 'points_earned') {
              column.formatter = function (value) {
                if (value || value === 0) {
                  return Number(value).toLocaleString('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                  });
                }
                return null;
              };
            }
            if (column.name == 'pos_transaction_type') {
              column.formatter = function (value) {
                return value;
              };
            }
            this.table.fields.push(column);
          }
        }
      });
    },

    setTableFilters(filters = {}) {
      if (Object.keys(filters).length !== 0) {
        this.table.appendedParams = filters;
        // setTimeout(() => this.setFilter(), 200);
      }
    },

    setTableSorts(sorts = []) {
      if (sorts && sorts.length > 0) {
        this.table.sortOrder = sorts;
        // setTimeout(() => this.setFilter(), 200);
      } else {
        this.table.sortOrder = sorts;
      }
    },

    getSortParam(sortOrder) {
      return sortOrder
        .map(function (sort) {
          return sort.field + '|' + sort.direction;
        })
        .join(',');
    },

    async onChangeReportType() {
      /** Get report data for the report type */
      this.getAccountReportData();

      /** Clear filters for the table */
      this.clearTableFilters();

      /** Reload table */
      this.setFilter();
    },

    clearTableFilters() {
      this.table.appendedParams.transaction_date_range = [
        moment(new Date()).format('YYYY-MM-DD'),
        moment(new Date()).format('YYYY-MM-DD')
      ];
      this.table.appendedParams.transaction_date_from = moment(
        new Date()
      ).format('YYYY-MM-DD');
      this.table.appendedParams.transaction_date_to = moment(new Date()).format(
        'YYYY-MM-DD'
      );
      this.table.appendedParams.terminal_codes = [];
      this.table.appendedParams.transaction_types = [];
      this.table.appendedParams.transaction_ids = '';
      this.table.appendedParams.name = '';
      this.table.appendedParams.membership_number = '';
      this.table.appendedParams.customer_types = [];
      this.table.appendedParams.site_concepts = [];
      this.table.appendedParams.companies = [];
      this.table.appendedParams.card_numbers = '';
      this.table.appendedParams.membership_program_ids = [];
      this.table.appendedParams.card_type_ids = [];
      this.table.appendedParams.site_ids = [];
      this.table.appendedParams.card_status_ids = [];
    },

    clearTableSorts() {
      this.table.sortOrder = null;
    },

    openDrawer(action) {
      this.drawer.visible = true;
      this.drawer.action = action;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.drawer.action = null;
    },

    setFilter() {
      this.table.appendedParams.filter = true;
      this.originalFilter === JSON.stringify(this.table.appendedParams)
        ? (this.updatedFilters = false)
        : (this.updatedFilters = true);

      if (
        this.table.appendedParams.name != '' &&
        this.table.appendedParams.name
      ) {
        const search = this.table.appendedParams.name.split('/');
        typeof search[0] != 'undefined'
          ? (this.table.appendedParams.first_name = search[0].trim())
          : '';
        typeof search[1] != 'undefined'
          ? (this.table.appendedParams.last_name = search[1].trim())
          : '';
      } else {
        this.table.appendedParams.first_name = null;
        this.table.appendedParams.last_name = null;
      }
      if (
        this.table.appendedParams.transaction_date_from != '' &&
        this.table.appendedParams.transaction_date_from &&
        !this.table.appendedParams.transaction_date_from.includes('00:00:00')
      ) {
        this.table.appendedParams.transaction_date_from =
          this.table.appendedParams.transaction_date_from + ' 00:00:00';
      }

      if (
        this.table.appendedParams.transaction_date_to != '' &&
        this.table.appendedParams.transaction_date_to &&
        !this.table.appendedParams.transaction_date_to.includes('23:59:59')
      ) {
        this.table.appendedParams.transaction_date_to =
          this.table.appendedParams.transaction_date_to + ' 23:59:59';
      }

      this.$root.$emit('refreshTable');
    },

    dateRangeOnChange(dateObj, dateString) {
      this.table.appendedParams.transaction_date_from = dateString[0];
      this.table.appendedParams.transaction_date_to = dateString[1];
      this.table.appendedParams.transaction_date_range = [
        dateString[0],
        dateString[1]
      ];
      // console.log('dateObj: ', dateObj);
      // this.setFilter();
    },
    serializeQuery(params, prefix) {
      const query = Object.keys(params).map((key) => {
        if (params[key]) {
          const value = params[key];

          if (params.constructor === Array) {
            key = `${prefix}[]`;
          } else if (params.constructor === Object) {
            key = prefix ? `${prefix}[${key}]` : key;
          }

          if (typeof value === 'object') {
            return this.serializeQuery(value, key);
          } else {
            return `${key}=${encodeURIComponent(value)}`;
          }
        }
      });

      let serializedQuery = query.filter((elem) => elem != '');

      return [].concat.apply([], serializedQuery).join('&');
    },
    setOrigConfig(event) {
      if (typeof event == 'number') {
        for (const template of this.options.accountReportTemplates) {
          if (event == template.id) {
            const jConfig = JSON.parse(template.config);
            if (Object.keys(jConfig).includes('filter')) {
              this.originalFilter = JSON.stringify(
                JSON.parse(jConfig.config).filters
              );
            } else {
              this.originalFilter = JSON.stringify(this.table.appendedParams);
            }
          }
        }
      } else {
        const jConfig = JSON.parse(event.config);
        if (Object.keys(jConfig).includes('filter')) {
          this.originalFilter = JSON.stringify(jConfig.filters);
        } else {
          this.originalFilter = JSON.stringify(this.table.appendedParams);
        }
      }
    }
  },
  created() {
    // this.getFilters();
    this.getSites();
    this.getTransactionTypes();
    this.getCustomerTypes();
    this.getSiteConcepts();
    this.getCompanies();
    this.getAccountReportData();

    this.$store.dispatch('setCurrentModule', 'TransactionReport');
  },
  mounted() {
    this.selectedActions = this.$store.getters.getModuleSelectedActions;
  },

  watch: {
    inHeadOffice: function () {
      if (this.inHeadOffice) {
        this.options.sites = secureStorage.getItem('visitingSites')
          ? secureStorage.getItem('visitingSites')
          : [];
      } else {
        this.options.sites = [secureStorage.getItem('currentSite')];
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions',
      headOfficeId: 'getHeadOffice'
    }),
    inHeadOffice() {
      return secureStorage.getItem('currentSiteId') == this.headOfficeId
        ? true
        : false;
    },
    tableFields() {
      const _tableFields = [...this.table.fields];
      return _tableFields;
    },

    tableApiUrl() {
      const tableApiUrl = this.table.apiUrl;
      const _tableParams = { ...this.table.appendedParams };
      _tableParams.export_data = true; // Update to true, for exportable data
      const _tableSort = [...this.table.sortOrder];
      let sorts, filters;

      /** Create query string for "sort" first if there are sorting */
      if (_tableSort.length > 0) {
        let i = 0;
        for (let sort of _tableSort) {
          if (i == 0) {
            sorts = 'sort=' + sort.field + '|' + sort.direction;
          } else {
            sorts += ',' + sort.field + '|' + sort.direction;
          }
          i++;
        }
      }

      /** Parse object for query string */
      filters = this.serializeQuery(_tableParams);
      if (tableApiUrl.includes('?')) {
        return tableApiUrl + '&' + sorts + '&' + filters;
      } else {
        return tableApiUrl + '?' + sorts + '&' + filters;
      }
    },

    toJsonFields: function () {
      const _tableFields = [...this.table.fields];
      let jsonFields = {};

      for (let field of _tableFields) {
        jsonFields[field.title] = field.name;
        switch (field.name) {
          case 'status':
            jsonFields[field.title] = {
              field: field.name,
              callback: (value) => {
                if (value === 'P') {
                  return 'Posted';
                }
                if (value === 'V') {
                  return 'Voided';
                }
                return null;
              }
            };
            break;
          case 'terminal_code':
          case 'transaction_id':
          case 'card_number':
            jsonFields[field.title] = {
              field: field.name,
              callback: (value) => {
                return '="' + value + '"';
              }
            };
            break;
          case 'points_earned':
            jsonFields[field.title] = {
              field: field.name,
              callback: (value) => {
                if (value || value === 0) {
                  return Number(value).toLocaleString('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                  });
                }
              }
            };
            break;
          case 'date':
            jsonFields[field.title] = {
              field: field.name,
              callback: (date) => {
                if (moment(date).isValid()) {
                  return moment(date).format('YYYY-MM-DD h:mm A');
                }
                return null;
              }
            };
            break;
        }
      }

      return jsonFields;
    }
  }
};
</script>

<style scoped></style>
